import axios from 'axios';

export const api = axios.create({
    baseURL: 'https://nanda-e-leo-backend.onrender.com/'
})